module.exports = __webpack_public_path__ + "bf760a421e019654da8a0c8047f4e0f1.svg";